/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { PaginationMetaDto } from './pagination-meta-dto';
import { ProgramDto } from './program-dto';
 /**
 *
 *
 * @export
 * @interface ProgramPaginatedResponseDto
 */
export interface ProgramPaginatedResponseDto {

    /**
     * @type {Array<ProgramDto>}
     * @memberof ProgramPaginatedResponseDto
     */
    data: Array<ProgramDto>;

    /**
     * @type {PaginationMetaDto}
     * @memberof ProgramPaginatedResponseDto
     */
    meta: PaginationMetaDto;
}
